import { FC, useContext } from "react";
import { QuizContext } from "../../providers/QuizProvider/QuizContext";
import { getStyleFromTextConfig } from "../../utils/style";
import { ResultItemMany } from "../ResultItem/ResultItemMany/ResultItemMany";
import { ResultItemOne } from "../ResultItem/ResultItemOne/ResultItemOne";
import { Container, Text, Title, Wraper } from "./ResultPage.styled";

type Props = {
  results: any[];
  currency: any;
  additions: any[];
  many_result?: boolean;
  onNext?: (linkTo: string) => void;
  lockBonus?: boolean;
};

export const ResultPage: FC<Props> = ({
  results,
  currency,
  additions,
  onNext,
  lockBonus = true,
  ...props
}) => {
  const {
    //many_result,
    after_contacts,
    result_design_type,
    result_title,
    result_title_config,
    result_description,
    result_description_config,
    addition_page_display,
    ...rest
  } = useContext(QuizContext);

  //console.log({results})

  const many_result = props.many_result ?? rest.many_result;
  return (
    <Container>
      {result_title && result_title_config && many_result && (
        <Wraper>
          <Title style={getStyleFromTextConfig(result_title_config)}>
            {result_title}
          </Title>
          <Text style={getStyleFromTextConfig(result_description_config)}>
            {result_description}
          </Text>
        </Wraper>
      )}
      {(many_result && (results?.length ?? 0) > 1) ? (
        <ResultItemMany
          //button_style={button_style}
          results={results}
          currency={currency}
          addition_page_display={addition_page_display}
          after_contacts={after_contacts ?? false}
          additions={additions}
          onNext={onNext}
          lockBonus={lockBonus}
        />
      ) : (
        results[0] && (
          <ResultItemOne
            key={results[0]?.id}
            //button_style={button_style}
            result={results[0]}
            currency={currency}
            addition_page_display={addition_page_display}
            additions={additions}
            after_contacts={after_contacts ?? false}
            onNext={() => onNext && onNext(results[0]?.button_link)}
            lockBonus={lockBonus}
          />
        )
      )}
    </Container>
  );
};
